export default __webpack_public_path__ + "static/media/151-measuring.9b16997c.png";